import React from 'react';
import { format, parseISO } from 'date-fns';
import { CloudRain } from 'lucide-react';
import { useWeather } from '../../components/WeatherWidget';

const HIGH_RAIN_THRESHOLD = 70;

function dayLabel(dateStr, idx) {
  if (idx === 0) return 'today';
  if (idx === 1) return 'tomorrow';
  const d = parseISO(dateStr);
  return Number.isNaN(d.getTime()) ? dateStr : format(d, 'EEEE');
}

export default function RainImpactAlert({ bookingCountByDate = {} }) {
  const { weather, status } = useWeather();

  if (status !== 'success' || !weather?.forecast?.length) return null;

  const affected = weather.forecast
    .map((day, idx) => {
      // Normalise to yyyy-MM-dd to match bookingCountByDate keys, in case the
      // forecast date arrives with a time component.
      const dateKey = String(day.date).slice(0, 10);
      return {
        date: dateKey,
        rain: day.chance_of_rain ?? 0,
        bookings: bookingCountByDate[dateKey] || 0,
        label: dayLabel(dateKey, idx),
      };
    })
    .filter((d) => d.rain >= HIGH_RAIN_THRESHOLD && d.bookings > 0);

  if (affected.length === 0) return null;

  return (
    <div className="rounded-xl border border-red-200 bg-red-50 p-4 dark:border-red-700 dark:bg-red-900/20">
      <div className="flex items-start gap-3">
        <CloudRain className="h-5 w-5 shrink-0 text-red-600 dark:text-red-400 mt-0.5" aria-hidden />
        <div className="min-w-0">
          <p className="text-sm font-semibold text-red-900 dark:text-red-100">
            Rain may impact scheduled bookings
          </p>
          <ul className="mt-1 space-y-0.5 text-sm text-red-800 dark:text-red-200">
            {affected.map((d) => (
              <li key={d.date}>
                Heavy rain expected{' '}
                <span className="font-medium capitalize">{d.label}</span> ({d.rain}%) —{' '}
                {d.bookings} booking{d.bookings === 1 ? '' : 's'} scheduled, consider notifying customers.
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
